import { createStyles } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import * as React from "react"
import { Redirect } from "react-router"
import { CCUtils, NumberMaybe } from "../../common/CCUtils"
import { log } from "../../common/Logging"
import { Month, MonthMaybe, TimeUtils } from "../../common/TimeUtils"
import { Student } from "../../shared/models/Student"
import { FormWrapper } from "../generic-components/FormWrapper"
import { useForm } from "../hooks/useForm"
import { appTheme } from "../StyleUtils"
import { LoginRoutes } from "../WebApp"
import { AuthStoreSA } from "./AuthStoreSA"
import { BirthdayPicker } from "./BirthdayPicker"
import { LoginDialog } from "./LoginDialog"
import { LoginPage } from "./LoginPage"
import { StudentAccountStore } from "./StudentAccountStore"

const useStyles = makeStyles(() =>
    createStyles({
        form: {
            "& > *": {
                marginBottom: appTheme.spacing(2.5)
            }
        }
    })
)

interface StudentCreateAccountState {
    loading: boolean
    valid: boolean
    student?: Student
}

export const StudentCreateAccount: React.FC = () => {
    const {form} = useStyles(appTheme)
    const {teacherName} = StudentAccountStore.instance
    const [accountState, setAccountState] = React.useState<StudentCreateAccountState>({loading: false, valid: false})
    const createAccount = async () => {
        setAccountState({loading: true, valid: false})
        const birthCode = TimeUtils.birthMonthAndDayToBirthCode(inputs.birthMonth as Month, inputs.birthDay as number)
        log.debug("Find student with auth store.")
        const student = await AuthStoreSA.instance.findStudent(inputs.studentId, birthCode)
        let valid = false
        if (student == null) {
            StudentAccountStore.instance.studentAccount = inputs
            StudentAccountStore.instance.birthCode = birthCode
            valid = true
        }
        setAccountState({loading: false, valid, student})
    }

    const initialValues = StudentAccountStore.instance.studentAccount

    const {handleInputChange, inputs} = useForm(initialValues)
    const isIncomplete = Object.values(inputs).includes("")

    if (StudentAccountStore.instance.classCode === "") {
        return <Redirect to={LoginRoutes.joinClass}/>
    }

    if (accountState.valid) {
        return <Redirect to={LoginRoutes.chooseBuddy} push={true}/>
    }

    const audioFile = CCUtils.asset("auth/register/enter-name-birthday.mp3")

    return (
        <LoginPage title={"Create an Account"} smallLogo={true}>
            <audio id="audio" src={audioFile} autoPlay/>
            {/*Login dialog will pop up if account already exists*/}
            {accountState.student != null && (
                <LoginDialog
                    dialogIsOpen={accountState.student != null}
                    onClose={() => setAccountState({loading: accountState.loading, valid: accountState.valid, student: undefined})}
                    student={accountState.student}
                    existingAccount={true}
                />
            )}
            <Typography variant={"body2"} style={{marginBottom: appTheme.spacing(4)}}>To join <b>{teacherName}'s</b> class, create an account.</Typography>
            <FormWrapper onClick={createAccount} className={form} buttonLabel={"Continue"} disabled={isIncomplete || accountState.loading} loading={accountState.loading}>
                <TextField
                    label={"First Name"}
                    name="firstName"
                    fullWidth={true}
                    autoFocus={true}
                    value={inputs.firstName}
                    onChange={handleInputChange}
                    required={true}
                />
                <TextField
                    label={"Last Name"}
                    fullWidth={true}
                    name={"lastName"}
                    value={inputs.lastName}
                    onChange={handleInputChange}
                    required={true}
                />
                <TextField
                    label={"Student ID"}
                    fullWidth={true}
                    name={"studentId"}
                    value={inputs.studentId}
                    onChange={handleInputChange}
                    required={true}
                    inputProps={{
                        autoCapitalize: "none",
                    }}
                />
                <BirthdayPicker
                    handleUpdate={handleInputChange}
                    birthMonth={inputs.birthMonth as MonthMaybe}
                    birthDay={inputs.birthDay as NumberMaybe}
                />
            </FormWrapper>
        </LoginPage>
    )
}